<template>
  <div>
    <v-select
      v-model="selectedPhoneCode"
      :items="sortedPhoneCodes"
      item-text="label"
      item-value="id"
      label="国番号*"
      class="phone-code-dropdown"
      @change="updatePhoneCode"
    >
      <template v-slot:item="{ item }">
        <div class="phone-item">
          <span class="flag">{{ item.flag }}</span>
          <span class="phone-label">+{{ item.value }}</span>
        </div>
      </template>
      <template v-slot:selection="{ item }">
        <div class="phone-item">
          <span class="flag">{{ item.flag }}</span>
          <span class="phone-label">+{{ item.value }}</span>
        </div>
      </template>
    </v-select>
    <input type="hidden" name="phone_country_code" :value="phoneCountryCode">
  </div>
</template>

<script>
export default {
  props: {
    phoneCountryCodes: {
      type: Object,
      default: () => ({}),
    },
    defaultPhoneCountryCode: {
      type: String,
      default: "81",
    },
  },
  data() {
    return {
      phoneCountryCode: this.defaultPhoneCountryCode || "81",
      selectedPhoneCode: "",
    };
  },
  computed: {
    sortedPhoneCodes() {
      return Object.entries(this.phoneCountryCodes)
        .map(([key, value]) => ({
          id: `${key}_${value}`,
          value: value,
          label: `${this.getFlagEmoji(key)} +${value}`,
          flag: this.getFlagEmoji(key),
        }))
        .sort((a, b) => a.id.localeCompare(b.id));
    },
  },
  watch: {
    defaultPhoneCountryCode: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.phoneCountryCode = newVal;
          const foundItem = this.sortedPhoneCodes.find(item => item.value === newVal);
          this.selectedPhoneCode = foundItem ? foundItem.id : "";
        }
      },
    },
    selectedPhoneCode(newVal) {
      if (newVal) {
        const countryCode = newVal.split("_")[1];
        this.phoneCountryCode = countryCode;
        this.$emit("update-phone-code", countryCode);
      }
    },
  },
  mounted() {
    this.phoneCountryCode = this.defaultPhoneCountryCode || "81";
  },
  methods: {
    getFlagEmoji(countryCode) {
      return countryCode
        .toUpperCase()
        .split("")
        .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
        .join("");
    },
    updatePhoneCode(selectedValue) {
      const countryCode = selectedValue.split("_")[1];
      this.phoneCountryCode = countryCode;
      this.$emit("update-phone-code", countryCode);
    }
  },
};
</script>

<style scoped>
.phone-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.flag {
  font-size: 1.5rem;
  width: 32px;
  text-align: center;
}
.phone-label {
  flex-grow: 1;
  text-align: left;
  min-width: 50px;
}
</style>
